"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectSimilarProductUseCase = void 0;
const react_1 = require("react");
const similarProducts_1 = require("../../repositories/similarProducts");
/**
 * Caso de uso que permite selecionar um produto similar para um SKU.
 */
function useSelectSimilarProductUseCase() {
    const similarProductsRepository = (0, react_1.useMemo)(() => new similarProducts_1.SimilarProductsRepository(), []);
    return (0, react_1.useCallback)((skuFrom, selectedProduct) => __awaiter(this, void 0, void 0, function* () {
        if (!selectedProduct) {
            similarProductsRepository.remove(skuFrom);
            return;
        }
        similarProductsRepository.add(skuFrom, selectedProduct);
    }), []);
}
exports.useSelectSimilarProductUseCase = useSelectSimilarProductUseCase;
